












import { Component, Vue } from 'vue-property-decorator';
import { issueListInstance } from '@/model/IssueListClass';
import EditIssueForm from './components/editIssueForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';

@Component({
  components: {
    EditIssueForm,
  },
})
export default class UpdateIssue extends Vue {
  private issueList = issueListInstance;
  get issue() {
    return this.issueList.editItem;
  }
  get issueInfo(): IIssue.IRequest.IUpdateIssueInfo {
    if (this.issue) {
      return {
        urgency: this.issue.urgency,
        title: this.issue.title,
        description: this.issue.description,
      };
    }
    return {
      urgency: 0,
      title: '',
      description: '',
    };
  }
  private changeIssue(
    issue: IIssue.IRequest.IUpdateIssueInfo,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!this.issue) {
        reject('Error');
        return;
      }
      issueListInstance
        .requestChangeItem(this.issue, issue)
        .then((res) => {
          resolve(res);
          this.goBack();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private goBack() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.go(-1);
  }
}
